import React, { useState } from 'react'
import NextImage from 'next/image'
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic'
const RichText = dynamic(() => import('../../RichText/RichText'))
import { Constants } from '../../../adapters/helpers/Constants'

export default function ProductShowMoreAccordion(props) {
    const {document: doc, productHighlights} = props;
    const highlightsLabel = doc?.fields?.highlightsLabel
    const seeMoreLabelIcon = doc?.fields?.seeMoreLabel?.fields?.icon.fields.file.url;
    const seeLessLabelIcon = doc?.fields?.seeLessLabel?.fields?.icon.fields.file.url;
    const highlightList = productHighlights
        ? Object.keys(productHighlights).map((key) => {
              return (
                  <li key={key} className={`ob-product-highlights__highlights-list-item ob-hyperlink-highlights-li `}>
                      <RichText document={productHighlights[key]} />
                  </li>
              )
          })
        : []

    const [mobileShowMore, setMobileShowMore] = useState(false)
    return (
        <div>
            <button
                onClick={() => {
                    setMobileShowMore(!mobileShowMore)
                }}
            >
                <span>{highlightsLabel}</span>
                <NextImage src={mobileShowMore ? seeMoreLabelIcon : seeLessLabelIcon} alt={(mobileShowMore ? doc?.fields?.seeMoreLabel?.fields?.icon?.fields?.title : doc?.fields?.seeLessLabel?.fields?.icon?.fields?.title) || Constants.chevrondown} width={20} height={8} />
            </button>
            {mobileShowMore && <ul>{highlightList}</ul>}
        </div>
    )
}

ProductShowMoreAccordion.propTypes = {
    document: PropTypes.object,
    productHighlights: PropTypes.object
}
